import { TeamMemberForDataExport_v1 } from "./TeamMemberForDataExport_v1";

export class TeamForDataExport_v1 {
    name: string;
    color: string;
    defaultRole: number;
    members: TeamMemberForDataExport_v1[];
}